import { RefillUnitType } from "@coworker/apprestructured/src/task-management/constants/RefillUnitType";

export type RefillQuantityDetail = {
  type: RefillUnitType;
  quantity: number;
  pieces: number;
};

function unitLabel(
  type: RefillUnitType,
  quantity: number,
  t: (key: string) => string
): string {
  switch (type) {
    case RefillUnitType.PALLET:
      return quantity === 1 ? t("palletUnit") : t("palletsUnit");
    case RefillUnitType.MULTIPACK:
      return quantity === 1 ? t("multiPackUnit") : t("multiPacksUnit");
    case RefillUnitType.PIECES:
    default:
      return quantity === 1 ? t("pieceUnit") : t("piecesUnit");
  }
}

export function refillQuantityLabel(
  refillQuantityDetail: RefillQuantityDetail | null,
  t: (key: string) => string
): string {
  if (!refillQuantityDetail || refillQuantityDetail.quantity === 0) {
    return "";
  }

  const { type, quantity, pieces } = refillQuantityDetail;
  const unit = unitLabel(type, quantity, t);

  if (type === RefillUnitType.PIECES) {
    return `${quantity} ${unit}`;
  }

  const piecesLabel = unitLabel(RefillUnitType.PIECES, pieces, t);

  return `${quantity} ${unit} (${pieces} ${piecesLabel})`;
}

export function refillChecklistLabel(
  refillQuantityDetail: RefillQuantityDetail | null,
  action: string,
  t: (key: string) => string
): string {
  if (!refillQuantityDetail || refillQuantityDetail.quantity === 0) {
    return "";
  }

  const { type, quantity } = refillQuantityDetail;
  const unit = unitLabel(type, quantity, t);

  return `${quantity} ${unit} ${action}`;
}
